import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EdgeResizer } from '~src/utils';
import { colSizes } from '~loader/loader-utils';
import ProjectActions from './ProjectActions';
import styles from './ProjectItem.module.scss';
import { getProjectPreviewState, getProjectThumbnails } from './previewState';

function ProjectItem(props) {
  const elementId = `user-canvas-${props.objectId}`;
  const [isDeleted, setIsDeleted] = useState(false);
  const {
    urls: currentPreviewUrls,
    hasPendingPreview,
  } = getProjectPreviewState(props.pages);
  const thumbnails = getProjectThumbnails({
    previewUrls: currentPreviewUrls,
    gifPreviewId: props.gifPreviewId,
    hasPendingPreview,
    videoCdnUrl: process.env.GIOTTO_VIDEO_CDN,
    fallbackUrl: `${process.env.OFC_CDN_URL}/logos/giotto_white.png`,
    resizePreview: (page) => new EdgeResizer(page).scaleToWidth(210),
  });

  useEffect(() => {
    if (isDeleted && props.setReload instanceof Function) {
      props.setReload([props.objectId]);
    }
  }, [isDeleted]);

  const [isActionsInputVisible, setIsActionsInputVisible] = React.useState(
    false
  );

  const url = `${process.env.ROUTE_CANVAS}/${props.objectId}`;
  return (
    <div
      id={elementId}
      style={{ display: isDeleted ? 'none' : 'block' }}
      data-user-canvas-id={props.objectId}
      className={`${colSizes['regular']} mt-5 block-default`}
      onMouseEnter={() => setIsActionsInputVisible(true)}
      onMouseLeave={() => setIsActionsInputVisible(false)}
    >
      <ProjectActions
        objectId={props.objectId}
        visible={isActionsInputVisible}
        setIsDeleted={setIsDeleted}
      />
      <a href={url} data-navigo>
        <div className="block-image">
          <div className={styles.imageProjectRecentContainer}>
            {thumbnails.map((thumbnail) => (
              <img
                key={thumbnail}
                className={`${styles.imageProjectNoText} ${
                  currentPreviewUrls.length === 0 ? styles.noBoxShadow : ''
                } ${thumbnails.length > 1 ? styles.widthTwoPages : ''}`}
                src={thumbnail}
                loading="lazy"
              />
            ))}
            {hasPendingPreview && (
              <span className={styles.previewStatus}>
                Anteprima in elaborazione
              </span>
            )}
          </div>
        </div>
      </a>
      <div className={styles.blockNameRecent}>
        <div className={styles.blockNameRecentTitle}>
          {props.metadata?.projectTypeName
            ? `${props.metadata?.projectTypeName}`
            : 'Progetto Senza Titolo'}{' '}
          {props.metadata?.formatName
            ? `${props.metadata?.formatName.replace('Orizzontale', '')}`
            : ''}
        </div>
        <div className={styles.blockNameRecentSubTitle}>
          {props.metadata?.templatesCategoryName
            ? `${props.metadata?.templatesCategoryName}`
            : ''}
          {' | '}
          {props.metadata?.servizioName}
        </div>
      </div>
    </div>
  );
}

ProjectItem.propTypes = {
  objectId: PropTypes.string,
  pages: PropTypes.array,
  gifPreviewId: PropTypes.string,
  name: PropTypes.string,
  metadata: PropTypes.object,
  setReload: PropTypes.func,
};

export default ProjectItem;
